/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Select_Folders_LabelInputs */



/**
* | output |
* | --- |
* | "Select Folders (Optional)" |
*
* @param {Spaces_Select_Folders_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_select_folders_label = /** @type {((inputs?: Spaces_Select_Folders_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Select_Folders_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner auswählen (Optional)")
	return /** @type {LocalizedString} */ ("Select Folders (Optional)")
});